import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { RiskExposureConfigViewModel, RiskExposureMode } from "./RiskExposure.types";

export function useRiskExposureConfig() {
    const { isLoading, data } = useDotLegalQuery<RiskExposureConfigViewModel>("/risk-global-settings/exposure-config");

    const exposureMode = data?.exposureMode ?? RiskExposureMode.None;

    return {
        isExposureConfigLoading: isLoading,
        exposureMode,
        exposureEnabled: exposureMode !== RiskExposureMode.None,
        exposureCurrencyCode: data?.exposureCurrencyCode ?? null,
        exposureScaleUpperBound: data?.exposureScaleUpperBound ?? null,
    };
}
